import { CoverageCode, VEBCoverageCode } from "../types/enrollment.types";

const coverage = ["Employee Only", "Employee & Spouse", "Employee & Dependents", "Employee & Family"];

export const COVERAGE = coverage;

export type VEBToGeneralCoverageCodeType = {
	[key in VEBCoverageCode]: CoverageCode;
};

export const VEBToGeneralCoverageCode: VEBToGeneralCoverageCodeType = {
	"Employee Only": "EE",
	"Employee & Spouse": "ES",
	"Employee & Dependents": "ED",
	"Employee & Family": "EF",
	"Employee & Children": "ECH"
};

export const VEB_TO_GENERAL_COVERAGE_CODE = VEBToGeneralCoverageCode;

const GeneralToVEBCoverageCode = {
	EE: "Employee Only",
	ES: "Employee & Spouse",
	ED: "Employee & Dependents",
	EF: "Employee & Family",
	ECH: "Employee & Children"
};

export const GENERAL_TO_VEB_COVERAGE_CODE = GeneralToVEBCoverageCode;
